import { render, staticRenderFns } from "./CampusAdvantagesUnderLogo.vue?vue&type=template&id=01578e46"
import script from "./CampusAdvantagesUnderLogo.vue?vue&type=script&lang=js"
export * from "./CampusAdvantagesUnderLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports